import { render } from "./management.cattle.io.setting.vue?vue&type=template&id=9d783740&scoped=true"
import script from "./management.cattle.io.setting.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.setting.vue?vue&type=script&lang=js"

import "./management.cattle.io.setting.vue?vue&type=style&index=0&id=9d783740&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d783740"]])

export default __exports__